<template>
  <div class="workflow-visualization" :style="roleStyles">
    <div ref="story" class="wv-story" @scroll.passive="requestScrollUpdate">
      <div class="wv-masthead">
        <div class="wv-eyebrow">{{ checkedWorkflow.masthead.eyebrow }}</div>
        <h1>
          {{ checkedWorkflow.masthead.headline }}<br /><em>{{ checkedWorkflow.masthead.emphasis }}</em>
        </h1>
        <p>{{ checkedWorkflow.masthead.intro }}</p>
      </div>
      <workflow-story-step
        v-for="(step, index) in checkedWorkflow.steps"
        :key="step.id"
        :step="step"
        :active="Number(step.number) === activeStep"
        :emphasis-terms="storyEmphasis[index]"
      />
      <div class="wv-tail" />
    </div>
    <workflow-map
      :workflow="checkedWorkflow"
      :active-step="activeStep"
      :progress="progress"
      @select-step="selectStep"
      @scroll-story="scrollStory"
    />
  </div>
</template>

<script>
import WorkflowStoryStep from './workflow-story-step.vue'
import WorkflowMap from './workflow-map.vue'
import WorkflowVisualizationMixin from './mixins/WorkflowVisualizationMixin'

export default {
  name: 'WorkflowVisualization',
  components: { WorkflowStoryStep, WorkflowMap },
  props: { workflow: { type: Object, required: true } },
  mixins: [WorkflowVisualizationMixin]
}
</script>

<style scoped>
.workflow-visualization {
  position: relative;
  display: grid;
  grid-template-columns: minmax(320px, 45%) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: var(--bg-component);
  font-family: 'Proxima Nova', Avenir, Helvetica, Arial, sans-serif;
}

.workflow-visualization::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    linear-gradient(90deg, var(--text-color-alpha2), transparent 34%),
    linear-gradient(180deg, var(--text-color-alpha2), transparent 18%);
  opacity: 0.12;
  pointer-events: none;
}

.wv-story {
  position: relative;
  z-index: 2;
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  padding: 0 72px 0 64px;
  scrollbar-width: thin;
  scrollbar-color: var(--border-color-base) transparent;
}

.wv-story::-webkit-scrollbar {
  width: 3px;
}
.wv-story::-webkit-scrollbar-thumb {
  background: var(--border-color-base);
  border-radius: 2px;
}

.wv-masthead {
  padding: 48px 0 36px;
  margin-bottom: 8px;
  border-bottom: 1px solid var(--border-color-split);
}

.wv-eyebrow {
  margin-bottom: 14px;
  color: var(--text-color-alpha4);
  font-size: 10.5px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
}

.wv-masthead h1 {
  margin: 0;
  color: var(--text-color);
  font-size: 44px;
  font-weight: 300;
  line-height: 1.04;
}

.wv-masthead h1 em {
  color: var(--wv-all);
  font-style: normal;
  font-weight: 700;
}

.wv-masthead p {
  max-width: 62ch;
  margin: 15px 0 0;
  color: var(--text-color-alpha6);
  font-size: 15px;
  line-height: 1.62;
}

.wv-tail {
  height: 50%;
}

@media (max-width: 1180px) {
  .workflow-visualization {
    grid-template-columns: 1fr;
    grid-template-rows: minmax(300px, 42%) minmax(0, 1fr);
    border-radius: 0;
  }
  .wv-story {
    grid-column: 1;
    grid-row: 2;
    padding: 0 28px;
  }
  .wv-masthead h1 {
    font-size: 34px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .wv-story {
    scroll-behavior: auto;
  }
}
</style>
